<app-navbar></app-navbar>
<div class="container-fluid">
    <div class="col-12 mt-5">
        <div class="row d-none d-lg-block d-xl-block">
            <div class="col-8 text-left">
                <h2>
                    <img src="../../../assets/img/catalog.png" width="50" alt=""> Catálogo de Productos:
                </h2>
            </div>
            <div class="col-4 text-right">
                <input type="text" class="form-control sch" [(ngModel)]="filterProducto" name="filterProducto" placeholder="Buscar producto..." autocomplete="off">
            </div>
        </div>
        <div class="col-12 mvl d-xs-block d-sm-block d-md-block d-lg-none d-xl-none">
            <div class="col-12 text-left">
                <h2>
                    <img src="../../../assets/img/catalog.png" width="50" alt=""> Catálogo de Productos:
                </h2>
            </div>
            <div class="col-12 text-right">
                <input type="text" class="form-control sch" [(ngModel)]="filterProducto" name="filterProducto" placeholder="Buscar producto..." autocomplete="off">
            </div>
        </div>
        <hr>
        <br>
        <div class="row row-cols-1 row-cols-md-5">
            <div class="col mb-4" *ngFor="let item of lista | filter:filterProducto">
                <div class="card h-100 producto" (click)="detalle(item)">
                    <span *ngIf="item.descuento > 0 && item.descuento" class="notify-badge">-{{item.descuento}}% 0FF</span>
                    <img [src]="item.imageProd" class="card-img-top">
                    <div class="card-body">
                    </div>
                    <div class="card-footer text-center">
                        <h3 class="card-title"><b>{{item.nombre | titlecase}}</b></h3>
                        <button class="btn btn-dark btn-block pedido">Ver Detalle</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>